import React, { createContext, useContext, useMemo } from 'react';
import { AnalyticsBrowser } from '@segment/analytics-next';

// TODO: Might need to add queueing events when Segment config is not ready

export interface AnalyticsService {
  analytics: AnalyticsBrowser | null;
}

const AnalyticsContext = createContext<AnalyticsService>({
  analytics: null,
});

const writeKey = process.env.REACT_APP_SEGMENT_KEY || '';

export const AnalyticsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const analytics = useMemo(
    () => AnalyticsBrowser.load({ writeKey }),
    [writeKey],
  );

  return (
    <AnalyticsContext.Provider value={{ analytics }}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalytics = (): AnalyticsService => {
  const context = useContext(AnalyticsContext);
  if (context === undefined) {
    throw new Error('useAnalytics must be used within an AnalyticsProvider');
  }
  return context;
};
